import { render } from "./SettingsPrinters.vue?vue&type=template&id=6d0d1eaf"
import script from "./SettingsPrinters.vue?vue&type=script&lang=js"
export * from "./SettingsPrinters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__